export default function arePreferencesValid(preferences) {
    return (typeof preferences === 'object' &&
        preferences !== null &&
        'isSoundEnabled' in preferences &&
        typeof preferences.isSoundEnabled === 'boolean');
}
